import Icon from '../components/Icon.vue'

Icon.register({
  hashtag: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M440.7 182.1c-1 5.5-6.3 9.9-11.8 9.9h-79.1l-22.9 128h74.8c7.5 0 13.1 6.8 11.8 14.1l-7.1 40c-1 5.5-6.3 9.9-11.8 9.9h-79.1l-15.4 86.1c-1 5.5-6.3 9.9-11.8 9.9h-40.6c-7.5 0-13.1-6.8-11.8-14.1l14.6-81.9h-98.6l-15.4 86.1c-1 5.5-6.3 9.9-11.8 9.9h-40.6c-7.5 0-13.1-6.8-11.8-14.1l14.6-81.9h-74.8c-7.5 0-13.1-6.8-11.8-14.1l7.1-40c1-5.5 6.3-9.9 11.8-9.9h79.1l22.9-128h-74.8c-7.5 0-13.1-6.8-11.8-14.1l7.1-40c1-5.5 6.3-9.9 11.8-9.9h79.1l15.4-86.1c1-5.5 6.3-9.9 11.8-9.9h40.6c7.5 0 13.1 6.8 11.8 14.1l-14.6 81.9h98.6l15.4-86.1c1-5.5 6.3-9.9 11.8-9.9h40.6c7.5 0 13.1 6.8 11.8 14.1l-14.6 81.9h74.8c7.5 0 13.1 6.8 11.8 14.1zM261.9 320l22.9-128h-98.6l-22.9 128h98.6z'
      }
    ]
  }
})
